import isOfferListStreamIncomplete from 'lib/offer/isOfferListStreamIncomplete'

type RawOfferList = Pick<
  App.OfferList,
  'offerIds' | 'fetching' | 'error' | 'streamEnded' | 'offerCount' | 'socketListenersStatus'
>

const EMPTY_RAW_OFFER_LIST: RawOfferList = {
  offerIds: [],
  fetching: true,
  error: null,
}

function holdHotelOfferListUntilStreamLimit(
  displayList: App.OfferList,
  rawList: RawOfferList | undefined,
  minRequiredOffers?: number,
): App.OfferList | undefined {
  if (!minRequiredOffers) {
    return undefined
  }

  if (!isOfferListStreamIncomplete(rawList ?? EMPTY_RAW_OFFER_LIST, minRequiredOffers)) {
    return undefined
  }

  return {
    ...displayList,
    fetching: true,
  }
}

export default holdHotelOfferListUntilStreamLimit
